import React from 'react';

/** @deprecated Use icons from icons-v2-generated instead. */
export interface ExploreCategoriesIconProps {
  color?: string;
  className?: string;
  width?: number;
  height?: number;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function ExploreCategoriesIcon({ 
  className = "w-6 h-6",
  width,
  height 
,
  color = 'white'
}: ExploreCategoriesIconProps) {
  return (
    <svg 
      className={className} 
      width={width}
      height={height}
      fill={color} 
      viewBox="0 0 21 21"
    >
      <path d="M17.9995 16.1245V14.125C17.9995 13.0895 17.16 12.25 16.1245 12.25H15.2485L9.9209 17.5777C9.48172 18.0168 8.76946 18.0165 8.33008 17.5777C7.89074 17.1383 7.89074 16.4262 8.33008 15.9868L15.4009 8.91604C16.1331 8.18381 16.1331 6.99544 15.4009 6.26321L13.9858 4.84964C13.2536 4.11752 12.0667 4.11744 11.3345 4.84964L9.9209 6.26321C9.48159 6.70251 8.76943 6.70244 8.33008 6.26321C7.89074 5.82387 7.89074 5.11173 8.33008 4.67239L9.74365 3.25882C11.3545 1.64794 13.9657 1.64802 15.5767 3.25882L16.9917 4.67239L17.2744 4.98587C18.502 6.49082 18.5063 8.65859 17.2905 10.1699C19.0007 10.6731 20.2495 12.2519 20.2495 14.125V16.1245C20.2495 18.4027 18.4027 20.2495 16.1245 20.2495H5.125C4.50368 20.2495 4 19.7459 4 19.1245C4.00025 18.5034 4.50383 17.9995 5.125 17.9995H16.1245C17.16 17.9995 17.9995 17.1601 17.9995 16.1245Z"/>
      <path d="M7.99951 4.125C7.99951 3.08947 7.16005 2.25 6.12451 2.25H4.125C3.08947 2.25 2.25 3.08947 2.25 4.125V16.125C2.25 17.1605 3.08947 18 4.125 18H6.12451C7.16005 18 7.99951 17.1605 7.99951 16.125V4.125ZM6.75 15.1245C6.75 16.0218 6.02273 16.7502 5.12549 16.7505C4.28423 16.7505 3.59168 16.1108 3.5083 15.2915L3.49951 15.1245L3.5083 14.959C3.59145 14.1395 4.28407 13.5 5.12549 13.5L5.29102 13.5088C6.11032 13.5919 6.74975 14.2833 6.75 15.1245ZM10.2495 16.125C10.2495 18.4032 8.40269 20.25 6.12451 20.25H4.125C1.84683 20.25 0 18.4032 0 16.125V4.125C3.8656e-07 1.84683 1.84683 0 4.125 0H6.12451C8.40269 0 10.2495 1.84683 10.2495 4.125V16.125Z"/>
    </svg>
  );
}